module.exports = __webpack_public_path__ + "static/img/avatar.9931175.png";


//////////////////
// WEBPACK FOOTER
// ./static/pawnProducts/avatar.png
// module id = CII/
// module chunks = 1